import { INTERVIEW_PATH } from "@/modules/recruiting/pages/interview/path";
import { generatePath, Navigate } from "react-router-dom";

export function OpenCandidateInterview() {
  const url = new URL(window.location.href);

  return (
    <Navigate
      to={generatePath(INTERVIEW_PATH, {
        interviewId: url.searchParams.get("id"),
      })}
    />
  );
}
